// EditLogic.js
import { useEffect, useState } from "react";
import CkDictionaryDs from "../../DataServices/CkDictionaryDs";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import { useLocation, useNavigate } from "react-router-dom";
import { insertLog } from "../Logs/InsertLog";


export function useEditLogic() {
    const ckDictionaryDs = new CkDictionaryDs();
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];
    const navigate = useNavigate();
    const [copyObject, setCopyObject] = useState({});
    const [openAddModal, setOpenAddModal] = useState(false);
    const [category, setCategory] = useState('');
    const [editObject, setEditObject] = useState({});
    const [displayId, setDisplayId] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [hasSubGroup, setHasSubGroup] = useState(false);
    const [displayView, setDisplayView] = useState("grid");
    const [isEditModeOn, setIsEditModeOn] = useState(false);
    // collapsed initially
    const [isItemListOpen, setIsItemListOpen] = useState(true);
    const [isPresetListOpen, setIsPresetListOpen] = useState(true);

    const [subGroups, setSubGroups] = useState([]);
    const [itemLists, setItemLists] = useState([]);
    const [presetList, setPresetList] = useState(null);


    const [isShowModel, setIsShowModel] = useState(false);
    const location = useLocation();
    const [dictionaryHeader, setDictionaryHeader] = useState({
        displayName: "",
        hasSubGroup: false,
        displayView: ""
    });

    const [isNew_SubGroup, setIsNew_SubGroup] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isHeaderDisabled, setIsHeaderDisabled] = useState(false);
    const [ck_dictionary_id, setCk_dictionary_id] = useState(localStorage.getItem("CkDictionaryId") || '');
    const [isSubGroupDisabled, setIsSubGroupDisabled] = useState(false);

    const isEditMode = ck_dictionary_id !== '';
    const { stopHudRotation, hud, showToast, showAlert } = useCustomContext();
    const [originalDictionaryHeader, setOriginalDictionaryHeader] = useState({});

    const toggleModal = () => {
        setOpenAddModal((prev) => !prev);
    }

    useEffect(() => {
        if (isEditMode) {
            fetchCkDictionaryById();
        } else {
            resetForAddMode();
        }
    }, [isEditMode]);

    const resetForAddMode = () => {
        setDisplayId("");
        setDisplayName("");
        setItemLists([]);
        setPresetList(null);
        // also keep accordions collapsed in add mode
        setIsItemListOpen(false);
        setIsPresetListOpen(false);
    };

    const fetchCkDictionaryById = async () => {
        hud("Please wait...");
        try {
            if (!ck_dictionary_id) {
                resetForAddMode();
                return;
            }

            //  setIsShowModel(false);

            const requestData = {
                ck_dictionary_id: ck_dictionary_id,
            };

            const response =
                await ckDictionaryDs.CK_Dictionary_Object_By_ID_GET(requestData);

            const data = response.data;
            const body =
                typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body?.data) {
                const dict = body.data;
                setCopyObject({ ...body.data });
                console.log('Actual Parsed Body', { ...body.data })


                setDisplayId(dict.ck_dictionary_id || "");
                setDictionaryHeader({
                    displayName: dict.display_text || "",
                    hasSubGroup: dict.item_having_subgroup || false,
                    displayView: dict.display_view || "grid"
                });
                setOriginalDictionaryHeader({
                    displayName: dict.display_text || "",
                    hasSubGroup: dict.item_having_subgroup || false,
                    displayView: dict.display_view || ""
                });

                const groups = (dict.item_collection?.item_groups || []).filter(Boolean);
                const hasGroups = groups.length > 0;

                setIsSubGroupDisabled(hasGroups);

                let updatedItemLists = [];
                let updatedSubGroups = [];

                if (dict.item_having_subgroup) {
                    updatedSubGroups = groups.map((group) => ({
                        displayText: group.display_text,
                        collapsed: Boolean(group.collapsable),
                        display: group.display || "show",
                        isOpen: false,
                        items: (group.item_subgroups || []).map((sub) => ({
                            ck_dictionary_id: ck_dictionary_id,
                            item_having_subgroup: dict.item_having_subgroup,
                            displayText: sub.display_text,
                            collapsed: Boolean(sub.collapsable),
                            display: sub.display || "show",
                            itemsCount: (sub.items || []).length,
                            items: sub.items || []
                        }))
                    }));

                    setSubGroups(updatedSubGroups);
                }

                else {
                    updatedItemLists = groups.map((group) => ({
                        ck_dictionary_id: ck_dictionary_id,
                        item_having_subgroup: dict.item_having_subgroup,
                        displayText: group.display_text,
                        display: group.display,
                        collapsed: String(group.collapsable) === "true",
                        itemsCount: group.items?.length || 0,
                        items: group.items || [],
                    }));

                    setItemLists(updatedItemLists);
                }

                const presetCollection = dict?.preset_collection ?? null;

                const hasValidPresetCollection = presetCollection && typeof presetCollection === "object" && Object.keys(presetCollection).length > 0

                if (hasValidPresetCollection) {

                    const presets = Array.isArray(presetCollection.presets)
                        ? presetCollection.presets
                        : [];
                    setPresetList({
                        ck_dictionary_id: ck_dictionary_id,
                        id: "preset-collection",
                        displayText: presetCollection?.display_text ?? "",
                        presetCount: presets.length,
                        presets: presetCollection.presets,
                    });
                } else {
                    setPresetList(null);
                }

            } else {
                resetForAddMode();

                showAlert(
                    body?.error || "Failed to fetch CK Dictionary.",
                    [{ label: "Ok", color: "var(--buttonColor)", onClick: () => { } }]
                );

                insertLog(
                    `${userName} failed to fetch CK Dictionary details for ID ${ck_dictionary_id}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    ck_dictionary_id || '',
                    'GET',
                    'CK_Dictionary_Object_By_ID_GET',
                    'FAILED',
                    'Failed to load CK Dictionary details'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch CK Dictionary with id: ${ck_dictionary_id}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                ck_dictionary_id,
                'GET',
                'CK_Dictionary_Object_By_ID_GET',
                'FAILED',
                err?.message
            );
            showAlert(
                err?.message || "Something went wrong while fetching CK Dictionary.",
                [{ label: "Ok", color: "var(--buttonColor)", onClick: () => { } }]
            );
        } finally {
            stopHudRotation();
        }
    };

    const toggleItemList = () => setIsItemListOpen((p) => !p);
    const togglePresetList = () => setIsPresetListOpen((p) => !p);

    const handleAddItemList = () => {
        setIsNew_SubGroup(false);
        setOpenAddModal(true);
        setEditObject({ ck_dictionary_id: ck_dictionary_id });
        setCategory('Item');
        setIsEditModeOn(false);

    };
    const handleAddPresetList = () => {
        setIsEditModeOn(false);
        setEditObject({ ck_dictionary_id: ck_dictionary_id });
        setOpenAddModal(true);
        setCategory('Preset');
    };
    const handleEditItemList = (obj, itemListIndex) => {
        setIsEditModeOn(true);
        setEditObject({
            ...obj,
            itemListIndex
        });
        setOpenAddModal(true);
        setCategory('Item');
    };

    const handleEditSubGroup = (sub, subIndex) => {
        setIsEditModeOn(true);
        setEditObject({ ...sub, subIndex });
        setOpenAddModal(true);
        setCategory('SubGroup');
    }
    const handleEditPresetList = (obj) => {
        setIsEditModeOn(true);
        setEditObject({
            ...obj
        });
        setOpenAddModal(true);
        setCategory('Preset');
    };

    const handleAddItem = (subIndex) => {
        const sub = subGroups[subIndex];
        setIsEditModeOn(false);
        setEditObject({ ck_dictionary_id: ck_dictionary_id, subIndex, subGroupName: sub?.displayText || "" }); // Pass subGroupName
        setCategory('Item');
        setOpenAddModal(true);
        setIsNew_SubGroup(false);

    };


    // Pass subGroupName along with item and indices
    const handleEditItemInSubGroup = (subIndex, itemIndex) => {
        const sub = subGroups[subIndex];
        if (!sub) return;

        const item = sub.items[itemIndex];
        setIsEditModeOn(true);
        setEditObject({
            ...item,
            subIndex,
            itemIndex,
            subGroupName: sub.displayText // ✅ add SubGroup name here
        });
        setCategory('Item');
        setOpenAddModal(true);
    };



    // const handleGenerateDictionary = () => {
    //     const presetCollectionRow = presetLists[0];

    //     const json = {
    //         [isEditMode ? "ck_dictionary_object" : "ck_dictionarys"]: [
    //             {
    //                 _id: copyObject._id,
    //                 display_text: displayName,
    //                 item_having_subgroup: hasSubGroup,
    //                 display_view: displayView,
    //                 item_collection: {
    //                     item_groups: hasSubGroup
    //                         ? buildItemGroupsWithSubGroups(subGroups)
    //                         : buildItemGroupsWithoutSubGroups(itemLists),
    //                 },

    //                 preset_collection: {
    //                     display_text: presetCollectionRow?.displayText || "",
    //                     presets: presetCollectionRow?.presets || []
    //                 },
    //             },
    //         ]
    //     };

    //     setGeneratedJson(json);

    //     setIsDictionaryModalOpen(true);
    // };

    function buildItemGroupsWithSubGroups(subGroups) {
        return subGroups.map(group => ({
            display_text: group.displayText,
            collapsable: Boolean(group.collapsed),
            display: group.display || "show",

            item_subgroups: (group.items || []).map(sub => ({
                display_text: sub.displayText,
                collapsable: Boolean(sub.collapsed),
                display: sub.display || "show",
                items: sub.items
            }))
        }));
    }

    function buildItemGroupsWithoutSubGroups(itemLists) {
        return itemLists.map(group => ({
            display_text: group.displayText,
            collapsable: Boolean(group.collapsed),
            display: group.display,
            items: group.items,
        }));
    }



    const deepEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (typeof a === "object" && a !== null && b !== null) {
            if (Array.isArray(a) !== Array.isArray(b)) return false;

            if (Array.isArray(a)) {
                if (a.length !== b.length) return false;
                return a.every((item, index) => deepEqual(item, b[index]));
            }

            const keysA = Object.keys(a);
            const keysB = Object.keys(b);

            if (keysA.length !== keysB.length) return false;

            return keysA.every((key) => deepEqual(a[key], b[key]));
        }

        return false;
    };





    const handleBack = () => {
        navigate(-1);
    };



    const handleSaveDictionary = async (e) => {
        e.preventDefault();

        try {

            const trimmedName = displayName.trim();
            if (!trimmedName) {
                setShowError(true);
                return;
            }

            if (!displayView) {
                showAlert("Display View is required.", [
                    { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
                ]);
                return;
            }

            const payload = {
                display_text: trimmedName,
                item_having_subgroup: hasSubGroup,
                display_view: displayView,
                item_collection: {
                    item_groups: []
                },
                created_by_email_id: useremail
            };

            console.log("Final Save Payload:", payload);

            hud("Please wait...");

            const response = await ckDictionaryDs.CK_Dictionary_Insert_Paritial(payload);
            const data = response?.data;
            const body =
                typeof data?.body === "string"
                    ? JSON.parse(data.body)
                    : data?.body;

            if (data?.statusCode === 200) {

                const savedId = body?.ck_dictionary_id;

                setCk_dictionary_id(savedId);
                localStorage.setItem("CkDictionaryId", savedId);

                setDictionaryHeader({
                    displayName: payload.display_text,
                    hasSubGroup: payload.item_having_subgroup,
                    displayView: payload.display_view
                });


                setIsHeaderDisabled(true);
                setIsShowModel(false);
                setDisplayName("");
                setHasSubGroup(false);
                setDisplayView("grid");

                insertLog(
                    `${userName} saved the CK Dictionary ${payload.display_text}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    savedId,
                    'INSERT',
                    'CK_Dictionary_Insert_Paritial',
                    'SUCCESS',
                    ''
                );

                showToast({ message: "CK dictionary saved successfully" });

            } else {
                stopHudRotation();
                showAlert(body?.errorMessage || "Failed to save CK dictionary", [
                    { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
                ]);
                insertLog(
                    `${userName} failed to save CK Dictionary ${displayName}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'INSERT',
                    'CK_Dictionary_Insert_Paritial',
                    'FAILED',
                    'Error while saving CK dictionary'
                );
            }

        } catch (error) {
            insertLog(
                `${userName} failed to save CK Dictionary ${displayName}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'INSERT',
                'CK_Dictionary_Insert_Paritial',
                'FAILED',
                error.message
            );
            stopHudRotation();
            showAlert(error.errorMessage || "Error while saving CK dictionary", [
                { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
            ]);
        } finally {
            stopHudRotation();
        }
    };

    const handleUpdateDictionary = async (updatedObject) => {
        try {

            const dataToUpdate = {
                ...updatedObject,
                updated_by_email_id: useremail   // ✅ ADD THIS
            };

            hud("Please wait...");

            console.log("Generated Json update", dataToUpdate)

            const response = await ckDictionaryDs.CK_Dictionary_Update_Paritial(dataToUpdate);

            const data = response?.data;
            const body =
                typeof data?.body === "string" ? JSON.parse(data.body) : data?.body;

            if (data?.statusCode === 200) {
                // navigate('/Ck_Dictionary');
                toggleModal();
                showToast({ message: body });
                await fetchCkDictionaryById(ck_dictionary_id);

                let logMessage = "";

                if (dataToUpdate?.sub_group && !dataToUpdate?.item_group) {
                    logMessage = `${userName} updated SubGroup "${dataToUpdate.sub_group.display_text}" (Dictionary ID: ${ck_dictionary_id})`;
                }

                if (dataToUpdate?.item_group) {
                    logMessage = `${userName} updated Item "${dataToUpdate.item_group.display_text}" (Dictionary ID: ${ck_dictionary_id})`;
                }

                if (dataToUpdate?.preset_collection) {
                    logMessage = `${userName} updated Preset "${dataToUpdate.preset_collection.display_text}" (Dictionary ID: ${ck_dictionary_id})`;
                }

                if (logMessage) {
                    if (logMessage) {
                        insertLog(
                            logMessage,
                            0,
                            useremail,
                            hud,
                            stopHudRotation,
                            showAlert,
                            ck_dictionary_id,
                            'UPDATE',
                            'CK_Dictionary_Update_Paritial',
                            'SUCCESS',
                            ''
                        );
                    }
                }


            } else {
                showAlert(body?.message || "Failed to save CK dictionary", [
                    {
                        label: "Ok",
                        color: 'var(--buttonColor)',
                        onClick: () => {
                        }
                    },
                ]);
                insertLog(
                    `${userName} failed to update CK Dictionary ${ck_dictionary_id}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    ck_dictionary_id,
                    'UPDATE',
                    'CK_Dictionary_Update_Paritial',
                    'FAILED',
                    'Failed to update CK dictionary'
                );
            }
        } catch (error) {
            insertLog(
                `${userName} failed to update CK Dictionary (Dictionary ID: ${ck_dictionary_id})`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                ck_dictionary_id,
                'UPDATE',
                'CK_Dictionary_Update_Paritial',
                'FAILED',
                error.message
            );
            showAlert(error.message || "Error while saving CK dictionary ", [
                {
                    label: "Ok",
                    color: 'var(--buttonColor)',
                    onClick: () => {
                    }
                },
            ]);
        } finally {
            stopHudRotation();
        }

    };

    const getJsonFromModal = (data) => {
        console.log("Category:", category, "Data:", data);

        let payload = {
            ck_dictionary_id: ck_dictionary_id,
            item_having_subgroup: dictionaryHeader.hasSubGroup
        };

        if (category === "SubGroup") {

            const newName = data.subGroupCollectionName?.toLowerCase().trim();

            const oldName = isEditModeOn
                ? editObject?.displayText?.toLowerCase().trim()
                : null;

            const isDuplicate = subGroups?.some((item) => {
                const existing = item.displayText?.toLowerCase().trim();

                // ignore current record during edit
                if (isEditModeOn && existing === oldName) return false;

                return existing === newName;
            });

            if (isDuplicate) {
                showAlert("A Sub Group with this display name already exists", [
                    { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
                ]);
                return;
            }

            payload.sub_group = {
                previous_display_text: isEditModeOn ? editObject?.displayText : undefined,
                display_text: data.subGroupCollectionName.trim(),
                collapsable: data.subGroupCollapsed,
                display: data.subGroupDisplay
            };
        }

        if (category === "Item") {

            const newName = data.collectionName?.toLowerCase().trim();

            const oldName = isEditModeOn
                ? editObject?.displayText?.toLowerCase().trim()
                : null;

            if (editObject?.subIndex !== undefined) {
                // Item inside SubGroup

                const currentSub = subGroups?.[editObject.subIndex];

                const isDuplicate = currentSub?.items?.some((item) => {
                    const existing = item.displayText?.toLowerCase().trim();

                    // ignore current editing item
                    if (isEditModeOn && existing === oldName) return false;

                    return existing === newName;
                });

                if (isDuplicate) {
                    showAlert("An Item with this display name already exists in the selected Sub Group", [
                        { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
                    ]);
                    return;
                }

                payload.sub_group = {
                    display_text: currentSub?.displayText,
                    collapsable: currentSub?.collapsed,
                    display: currentSub?.display
                };

            } else {

                const isDuplicate = itemLists?.some((item) => {
                    const existing = item.displayText?.toLowerCase().trim();

                    if (isEditModeOn && existing === oldName) return false;

                    return existing === newName;
                });

                if (isDuplicate) {
                    showAlert("An Item with this display name already exists", [
                        { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
                    ]);
                    return;
                }
            }

            payload.item_group = {
                previous_display_text: isEditModeOn ? editObject?.displayText : undefined,
                display_text: data.collectionName.trim(),
                collapsable: data.collapsed,
                display: data.display,
                items: Array.isArray(data.items) ? data.items : []
            };
        }

        if (category === "Preset") {

            payload.preset_collection = {
                display_text: data.collectionName.trim(),
                presets: Array.isArray(data.items) ? data.items : []
            };
        }

        console.log("Final Payload:", payload);

        handleUpdateDictionary(payload);
    };

    const handleAddSubGroup = () => {
        setIsNew_SubGroup(true);
        setIsEditModeOn(false);
        setEditObject({});
        setOpenAddModal(true);
        setCategory('SubGroup');
    }


    const handleDeleteItem = async (displayText) => {
        showAlert(
            "Are you sure you want to delete this Item list?",
            [
                {
                    label: "Cancel",
                    color: "gray",
                    onClick: () => { }
                },
                {
                    label: "Delete",
                    color: "red",
                    onClick: async () => {
                        try {
                            const requestData = {
                                ck_dictionary_id: ck_dictionary_id,
                                display_text: displayText,
                                updated_by_email_id: useremail
                            };

                            hud("Please wait...");

                            const response = await ckDictionaryDs.CK_Dictionary_Partial_Delete(requestData);
                            const data = response?.data;
                            const body = typeof data?.body === "string" ? JSON.parse(data.body) : data?.body;

                            if (data?.statusCode === 200) {
                                showToast({ message: body.message });
                                await fetchCkDictionaryById(ck_dictionary_id);
                                insertLog(
                                    `${userName} deleted item "${displayText}" (Dictionary ID: ${ck_dictionary_id})`,
                                    0,
                                    useremail,
                                    hud,
                                    stopHudRotation,
                                    showAlert,
                                    ck_dictionary_id,
                                    'DELETE',
                                    'CK_Dictionary_Partial_Delete',
                                    'SUCCESS',
                                    ''
                                );
                            } else {
                                showAlert(body?.message || body?.error || "Failed to delete Item", [
                                    {
                                        label: "Ok",
                                        color: "var(--buttonColor)",
                                        onClick: () => { }
                                    }
                                ]);
                            }
                        } catch (error) {
                            insertLog(
                                `${userName} failed to delete item "${displayText}" (Dictionary ID: ${ck_dictionary_id})`,
                                0,
                                useremail,
                                hud,
                                stopHudRotation,
                                showAlert,
                                ck_dictionary_id,
                                'DELETE',
                                'CK_Dictionary_Partial_Delete',
                                'FAILED',
                                error.message
                            );
                            showAlert(error.message || error.error || "Error while deleting Item", [
                                {
                                    label: "Ok",
                                    color: "var(--buttonColor)",
                                    onClick: () => { }
                                }
                            ]);
                        } finally {
                            stopHudRotation();
                        }
                    }
                }
            ]
        );
    };

    const handleDeleteItemInSub = (subGroupName, displayText) => {

        showAlert(
            "Are you sure you want to delete this Item list?",
            [
                {
                    label: "Cancel",
                    color: "gray",
                    onClick: () => { }
                },
                {
                    label: "Delete",
                    color: "red",
                    onClick: async () => {
                        try {
                            const requestData = {
                                ck_dictionary_id: ck_dictionary_id,
                                group_display_text: subGroupName,
                                display_text: displayText,
                                updated_by_email_id: useremail
                            };

                            hud("Please wait...");

                            const response = await ckDictionaryDs.CK_Dictionary_Partial_Delete(requestData);
                            const data = response?.data;
                            const body = typeof data?.body === "string" ? JSON.parse(data.body) : data?.body;

                            if (data?.statusCode === 200) {
                                showToast({ message: body.message });
                                await fetchCkDictionaryById(ck_dictionary_id);

                                insertLog(
                                    `${userName} deleted item "${displayText}" in subgroup "${subGroupName}" (Dictionary ID: ${ck_dictionary_id})`,
                                    0,
                                    useremail,
                                    hud,
                                    stopHudRotation,
                                    showAlert,
                                    ck_dictionary_id,
                                    'DELETE',
                                    'CK_Dictionary_Partial_Delete',
                                    'SUCCESS',
                                    ''
                                );
                            } else {
                                showAlert(body?.message || body?.error || "Failed to delete Item", [
                                    {
                                        label: "Ok",
                                        color: "var(--buttonColor)",
                                        onClick: () => { }
                                    }
                                ]);
                            }
                        } catch (error) {
                            insertLog(
                                `${userName} failed to delete item "${displayText}" in subgroup "${subGroupName}" (Dictionary ID: ${ck_dictionary_id})`,
                                0,
                                useremail,
                                hud,
                                stopHudRotation,
                                showAlert,
                                ck_dictionary_id,
                                'DELETE',
                                'CK_Dictionary_Partial_Delete',
                                'FAILED',
                                error.message
                            );
                            showAlert(error.message || error.error || "Error while deleting Item", [
                                {
                                    label: "Ok",
                                    color: "var(--buttonColor)",
                                    onClick: () => { }
                                }
                            ]);
                        } finally {
                            stopHudRotation();
                        }
                    }
                }
            ]
        );
    };

    const handleDeletePreset = async (displayText) => {
        showAlert(
            "Are you sure you want to delete this Preset list?",
            [
                {
                    label: "Cancel",
                    color: "gray",
                    onClick: () => { }
                },
                {
                    label: "Delete",
                    color: "red",
                    onClick: async () => {
                        try {
                            const requestData = {
                                ck_dictionary_id: ck_dictionary_id,
                                preset_display_text: displayText,
                                updated_by_email_id: useremail
                            };

                            hud("Please wait...");

                            const response = await ckDictionaryDs.CK_Dictionary_Partial_Delete(requestData);
                            const data = response?.data;
                            const body = typeof data?.body === "string" ? JSON.parse(data.body) : data?.body;

                            if (data?.statusCode === 200) {
                                showToast({ message: body.message });
                                await fetchCkDictionaryById(ck_dictionary_id);
                                insertLog(
                                    `${userName} deleted "${displayText}" (Dictionary ID: ${ck_dictionary_id})`,
                                    0,
                                    useremail,
                                    hud,
                                    stopHudRotation,
                                    showAlert,
                                    ck_dictionary_id,
                                    'DELETE',
                                    'CK_Dictionary_Partial_Delete',
                                    'SUCCESS',
                                    ''
                                );
                            } else {
                                showAlert(body?.message || body?.error || "Failed to delete Item", [
                                    {
                                        label: "Ok",
                                        color: "var(--buttonColor)",
                                        onClick: () => { }
                                    }
                                ]);
                            }
                        } catch (error) {
                            insertLog(
                                `${userName} failed to delete preset "${displayText}" (Dictionary ID: ${ck_dictionary_id})`,
                                0,
                                useremail,
                                hud,
                                stopHudRotation,
                                showAlert,
                                ck_dictionary_id,
                                'DELETE',
                                'CK_Dictionary_Partial_Delete',
                                'FAILED',
                                error.message
                            );
                            showAlert(error.message || error.error || "Error while deleting Item", [
                                {
                                    label: "Ok",
                                    color: "var(--buttonColor)",
                                    onClick: () => { }
                                }
                            ]);
                        } finally {
                            stopHudRotation();
                        }
                    }
                }
            ]
        );
    };

    const handleUpdateBasicInfo = async (e) => {
        e.preventDefault();

        const { displayName, hasSubGroup, displayView } = dictionaryHeader;

        if (!displayName || displayName.trim() === "") {
            showAlert("Collection Name is required", [
                {
                    label: "Ok",
                    color: "var(--buttonColor)",
                    onClick: () => { }
                }
            ]);
            return;
        }

        const isNoChanges =
            displayName.trim() === originalDictionaryHeader.displayName &&
            hasSubGroup === originalDictionaryHeader.hasSubGroup &&
            displayView === originalDictionaryHeader.displayView;

        if (isNoChanges) {
            showAlert("No changes are identified", [
                {
                    label: "Ok",
                    color: "var(--buttonColor)",
                    onClick: () => { }
                }
            ]);
            return;
        }

        try {
            hud("Please wait...");

            const payload = {
                _id: ck_dictionary_id,
                display_text: displayName.trim(),
                display_view: displayView,
                updated_by_email_id: useremail
            };

            if (!isSubGroupDisabled) {
                payload.item_having_subgroup = hasSubGroup;
            }

            console.log("Payload:", payload);

            const response = await ckDictionaryDs.CK_Dictionary_Update({
                ck_dictionary_object: payload
            });

            const data = response?.data;
            const body =
                typeof data?.body === "string"
                    ? JSON.parse(data.body)
                    : data?.body;

            if (data?.statusCode === 200) {
                showToast({ message: "Ck dictionary updated successfully" });
                await fetchCkDictionaryById(ck_dictionary_id);
                insertLog(
                    `${userName} updated the Ck Dictionary with id:${ck_dictionary_id}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    ck_dictionary_id,
                    'UPDATE',
                    'CK_Dictionary_Update',
                    'SUCCESS',
                    ''
                );
            } else {
                showAlert(body?.error || "Failed to update CK Dictionary", [
                    { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
                ]);
            }
        } catch (error) {
            insertLog(
                `${userName} failed to update CK Dictionary with id:${ck_dictionary_id}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                ck_dictionary_id,
                'UPDATE',
                'CK_Dictionary_Update',
                'FAILED',
                error?.error || error?.message
            );
            showAlert(error?.error || "Error while updating CK Dictionary", [
                { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
            ]);
        } finally {
            stopHudRotation();
        }
    };





    return {
        displayId,
        displayName,
        setDisplayId,
        setDisplayName,
        isEditMode,
        ck_dictionary_id,

        isItemListOpen,
        isPresetListOpen,
        toggleItemList,
        togglePresetList,

        itemLists,
        presetList,

        handleAddItemList,
        handleAddPresetList,
        handleEditItemList,
        handleEditPresetList,
        handleSaveDictionary,
        handleUpdateDictionary,

        openAddModal,
        setOpenAddModal,
        toggleModal,
        category,
        editObject,
        getJsonFromModal,
        hasSubGroup,
        setHasSubGroup,
        handleAddSubGroup,
        setSubGroups,
        subGroups,
        handleEditSubGroup,
        handleAddItem, handleEditItemInSubGroup, isEditModeOn, handleBack, setDisplayView, displayView,
        isShowModel, setIsShowModel, dictionaryHeader, setDictionaryHeader, location, isNew_SubGroup, setIsNew_SubGroup, showError, setShowError,
        isHeaderDisabled, handleDeleteItem, handleDeleteItemInSub, handleUpdateBasicInfo, isSubGroupDisabled, handleDeletePreset
    };
}
